import React, { useRef, useState } from 'react';
import { Canvas, useThree } from '@react-three/fiber';
import { OrbitControls } from '@react-three/drei';
import PictureMesh from './PictureMesh';
import GridLines from './GridLines';
import Model from './Model';
import PerspectiveCameraSetup from './PerspectiveCameraSetup';
import { Input } from '../form/input';

const Scene = ({ marker, model, scaleObject, positionObject, rotateObject }) => {

    return (
        <>
            <ambientLight intensity={0.5} />
            <pointLight position={[0, 0, -10]} intensity={10} />
            <directionalLight
                position={[0, 100, 100]}
                intensity={10}
            />
            <GridLines size={100} divisions={100} color1="black" color2="gray" />
            <PerspectiveCameraSetup />
            <PictureMesh url={marker} position={[0, 0, 0]} />
            <Model url={model} scale={scaleObject} position={positionObject} rotate={rotateObject} />
        </>
    );
};

const ThreeDScene = ({ marker, model, scaleObject, setScaleObject, positionObject, setPositionObject, rotateObject, setRotateObject }) => {
    const markerURL = URL.createObjectURL(marker);
    const contentURL = URL.createObjectURL(model);

    return (
        <div className='grid grid-row-12 grid-flow-row gap-2 h-full'>
            <div className="row-span-8 w-full">
                <Canvas className='rounded-lg'>
                    <Scene
                        marker={markerURL}
                        model={contentURL}
                        scaleObject={scaleObject}
                        positionObject={positionObject}
                        rotateObject={rotateObject}
                    />
                </Canvas>
            </div>

            <div className="row-span-4 w-full">
                <div className='grid grid-cols-12 gap-2'>
                    <div className="col-span-2 relative border border-gray-300 rounded-lg divide-y p-2">
                        <div className='mb-1 text-gray-600'>مقیاس</div>
                        <div className="grid grid-cols-12 gap-2">
                            <div className='col-span-12'>
                                <div className='m-1 text-gray-600'>x, y, z</div>
                                <Input
                                    type="number"
                                    id="scale"
                                    name="scale"
                                    step="0.1"
                                    autoComplete={"off"}
                                    value={scaleObject}
                                    requiredir={true}
                                    onChange={(e) => {
                                        setScaleObject(e.target.value);
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="col-span-5 relative border border-gray-300 rounded-lg divide-y p-2">
                        <div className='mb-1 text-gray-600'>موقعیت</div>
                        <div className="grid grid-cols-12 gap-2">
                            <div className='col-span-4'>
                                <div className='m-1 text-gray-600'>x</div>
                                <Input
                                    type="number"
                                    id="position-x"
                                    name="position-x"
                                    step="0.1"
                                    autoComplete={"off"}
                                    value={positionObject.x}
                                    requiredir={true}
                                    onChange={(e) => {
                                        setPositionObject((prevState) => ({
                                            ...prevState,
                                            x: e.target.value,
                                        }));
                                    }}
                                />
                            </div>
                            <div className='col-span-4'>
                                <div className='m-1 text-gray-600'>y</div>
                                <Input
                                    type="number"
                                    id="position-y"
                                    name="position-y"
                                    step="0.1"
                                    autoComplete={"off"}
                                    value={positionObject.y}
                                    requiredir={true}
                                    onChange={(e) => {
                                        setPositionObject((prevState) => ({
                                            ...prevState,
                                            y: e.target.value,
                                        }));
                                    }}
                                />
                            </div>
                            <div className='col-span-4'>
                                <div className='m-1 text-gray-600'>z</div>
                                <Input
                                    type="number"
                                    id="position-z"
                                    name="position-z"
                                    step="0.1"
                                    autoComplete={"off"}
                                    value={positionObject.z}
                                    requiredir={true}
                                    onChange={(e) => {
                                        setPositionObject((prevState) => ({
                                            ...prevState,
                                            z: e.target.value,
                                        }));
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="col-span-5 relative border border-gray-300 rounded-lg divide-y p-2">
                        <div className='mb-1 text-gray-600'>چرخش</div>
                        <div className="grid grid-cols-12 gap-2">
                            <div className='col-span-4'>
                                <div className='m-1 text-gray-600'>x</div>
                                <Input
                                    type="number"
                                    id="rotate-x"
                                    name="rotate-x"
                                    step="0.1"
                                    autoComplete={"off"}
                                    value={rotateObject.x}
                                    requiredir={true}
                                    onChange={(e) => {
                                        setRotateObject((prevState) => ({
                                            ...prevState,
                                            x: e.target.value,
                                        }));
                                    }}
                                />
                            </div>
                            <div className='col-span-4'>
                                <div className='m-1 text-gray-600'>y</div>
                                <Input
                                    type="number"
                                    id="rotate-y"
                                    name="rotate-y"
                                    step="0.1"
                                    autoComplete={"off"}
                                    value={rotateObject.y}
                                    requiredir={true}
                                    onChange={(e) => {
                                        setRotateObject((prevState) => ({
                                            ...prevState,
                                            y: e.target.value,
                                        }));
                                    }}
                                />
                            </div>
                            <div className='col-span-4'>
                                <div className='m-1 text-gray-600'>z</div>
                                <Input
                                    type="number"
                                    id="rotate-z"
                                    name="rotate-z"
                                    step="0.1"
                                    autoComplete={"off"}
                                    value={rotateObject.z}
                                    requiredir={true}
                                    onChange={(e) => {
                                        setRotateObject((prevState) => ({
                                            ...prevState,
                                            z: e.target.value,
                                        }));
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default ThreeDScene;
